module.exports = __webpack_public_path__ + "media/R05.db05340c.mp4";